export default __webpack_public_path__ + "static/media/forgot.03b2e230.svg";